var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mr-1",attrs:{"src":require("../assets/g3tools-orange-64x64.png"),"width":"32"}}),_c('span',{staticClass:"g3tools-nav ml-1 mr-1"},[_vm._v(">g3tools")])])
}]

export { render, staticRenderFns }